module.exports = __webpack_public_path__ + "img/expiredQR.e0bea743.png";